import { render, staticRenderFns } from "./PlankForm.vue?vue&type=template&id=73632094"
import script from "./PlankForm.vue?vue&type=script&lang=js"
export * from "./PlankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports